import ExaminationPrint from './ExaminationPrint';

export default ExaminationPrint;
